/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Page for which service agreements are listed
 * @export
 */
export const ServiceAgreementListCategory = {
    PrivateBanking: 'PRIVATE_BANKING',
    Waivers: 'WAIVERS'
} as const;
export type ServiceAgreementListCategory = typeof ServiceAgreementListCategory[keyof typeof ServiceAgreementListCategory];


export function instanceOfServiceAgreementListCategory(value: any): boolean {
    for (const key in ServiceAgreementListCategory) {
        if (Object.prototype.hasOwnProperty.call(ServiceAgreementListCategory, key)) {
            if (ServiceAgreementListCategory[key as keyof typeof ServiceAgreementListCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceAgreementListCategoryFromJSON(json: any): ServiceAgreementListCategory {
    return ServiceAgreementListCategoryFromJSONTyped(json, false);
}

export function ServiceAgreementListCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementListCategory {
    return json as ServiceAgreementListCategory;
}

export function ServiceAgreementListCategoryToJSON(value?: ServiceAgreementListCategory | null): any {
    return value as any;
}

export function ServiceAgreementListCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): ServiceAgreementListCategory {
    return value as ServiceAgreementListCategory;
}

